import { generateFullName } from '@/shared/lib';
import type { Physician } from '../model/physician.types';

/**
 * Builds the label shown for a physician in a select option. Starts from the physician's first and last name and appends the NPI after a dash when the physician has one.
 *
 * @param physician - Physician record supplying the name and NPI.
 * @returns Physician label, optionally suffixed with the NPI.
 */
const formatPhysicianOptionLabel = (physician: Physician) => {
  let label = generateFullName(physician);
  if (physician.npi) {
    label += ` - ${physician.npi}`;
  }
  return label;
};

export { formatPhysicianOptionLabel };
